import { ActionButton } from './ui/ActionButton';
import React, { type ComponentPropsWithoutRef } from 'react';
import { PiSparkleBold } from 'react-icons/pi';

/** Shared entry point for AI actions; colors live in interaction-accent.css. */
export function AiActionButton({ children, className = '', type = 'button', ...props }: ComponentPropsWithoutRef<'button'>) {
  return <ActionButton {...props} type={type} variant="primary" wrap className={`ai-action-button ${className}`}>
    <PiSparkleBold aria-hidden="true" />
    <span>{children}</span>
  </ActionButton>;
}
